import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { context } from '../AppContext';
import Locale from "../../locale/Locale";

export default class ConfigHistory extends React.Component {
    state = {
        history: [],
        selecteditem: 0
    };

    componentDidMount() {
        this.getConfigHistory();
    }

    async getConfigHistory(fileName = null) {
        let configHistory = await context.makeRequest("Site.getConfigHistory", {
            siteId: this.props.site.id,
            fileName: this.props.fileName
        }).catch(err => {
            console.log("Error loading config history!", err.message);
        });
        console.log(configHistory.result);
        this.setState({
            history: configHistory.result
        });
    }

    async restoreConfig(historyItem) {
        let configSetResp = await context.makeRequest("Site.setConfig", {
            siteId: this.props.site.id,
            fileName: this.props.fileName,
            data: historyItem.Data
        });
        alert("Config restored");
        this.getConfigHistory();
    }

    getItemDetails() {
        if (this.state.history.length === 0) {
            return "None found";
        } else if (!this.state.history[this.state.selectedItem]) {
            return "Select an item!";
        }
        return (
            <div key='newVersion' style={{ 
                flex: 1, 
                verticalAlign: "top", 
                flexDirection: 'column'
            }}
            >
                <div style={{ }}>
                    <div style={{ }}>
                        {
                            this.state.history[this.state.selectedItem].FileName + " / " +
                            Locale.formatDateTime(this.state.history[this.state.selectedItem].time) + " / " +
                            this.state.history[this.state.selectedItem].SourceName
                        }
                    </div>
                    <div style={{ float: 'right' }}>
                        <Button 
                            style={{ align: 'right' }}
                            variant="primary" 
                            onClick={ () => { this.restoreConfig(this.state.history[this.state.selectedItem]) }}
                        >Restore</Button>
                    </div>
                </div>
                <div style={{ height: 500, overflowY: "auto" }}>
                    <pre>{ JSON.stringify(this.state.history[this.state.selectedItem].Data, null, 2) }</pre>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div key='saves' style={{ 
                    width: 150, flexDirection: 'column' 
                }}>
                    {
                        this.state.history.map((hItem, key) => {
                            let source = null;
                            let device = this.props.site.devices.find(dev => dev.uuid === hItem.SourceName);
                            if (device)
                                source = "Device " + device.deviceNumber;
                            return (
                                <div 
                                    className="listItem"
                                    key={ hItem.time } 
                                    onClick={() => this.setState({ selectedItem: key }) }
                                >
                                    { Locale.formatDateTime(hItem.time) }<br/>
                                    { source || hItem.SourceName || hItem.Source }
                                </div>
                            );
                        })
                    }
                </div>
                { this.getItemDetails() }
            </div>
        );
    }
}